<template>
  <div id="payment_summary">
    <v-card-text>
      <v-row class="d-flex align-center">
        <v-col cols="6">
          <h3>Payment Summary</h3>
        </v-col>
        <v-col cols="6">
          <span class="float-right">
            <span class="mr-4 font-weight-bold dashboard-blue">Export</span>
            <v-icon color="#3371E2">mdi-export</v-icon>
          </span>
        </v-col>
      </v-row>
    </v-card-text>
    <v-data-table
      :headers="headers"
      :items="invoices"
      hide-default-footer
      disable-pagination
    >
      <!-- eslint-disable-next-line -->
      <template v-slot:item.invoice_no="{ item }">
        <router-link
          :to="{
            name: '',
            params: {
              id: item.id,
            },
          }"
        >
          <h4>{{ item.invoice_no }}</h4>
        </router-link>
      </template>

      <!-- eslint-disable-next-line -->
      <template v-slot:item.po_no="{ item }">
        <h4 v-if="item.po_no">{{ item.po_no }}</h4>
        <span v-else>__</span>
      </template>

      <!-- eslint-disable-next-line -->
      <template v-slot:item.client="{ item }">
        <h4>{{ item.client }}</h4>
      </template>

      <!-- eslint-disable-next-line -->
      <template v-slot:item.campaign_name="{ item }">
        <h4 class="text--disabled">{{ item.campaign_name }}</h4>
      </template>

      <!-- eslint-disable-next-line -->
      <template v-slot:item.invoice_date="{ item }">
        <h4>{{ item.invoice_date }}</h4>
      </template>

      <!-- eslint-disable-next-line -->
      <template v-slot:item.invoice_total="{ item }">
        <h4>{{ item.invoice_total }}</h4>
      </template>

      <!-- eslint-disable-next-line -->
      <template v-slot:item.status="{ item }">
        <h4>{{ item.status }}</h4>
      </template>

      <!-- eslint-disable-next-line -->
      <template v-slot:item.settled_date="{ item }">
        <h4>{{ item.settled_date }}</h4>
      </template>

      <!-- eslint-disable-next-line -->
      <template v-slot:item.method_of_payment="{ item }">
        <h4>{{ item.method_of_payment }}</h4>
      </template>
    </v-data-table>
    <v-card-actions class="pa-4">
      <v-spacer></v-spacer>
    </v-card-actions>
  </div>
</template>

<script>
export default {
  props: {
    invoices: {
      type: Array,
      default: null,
    },
    headers: {
      type: Array,
      default: null,
    },
  },
  data() {
    return {
      display: 10,
      items: [5, 10, 15, 20],
      pagination: {
        perPage: 10,
        currentPage: 1,
        perPageOptions: [1, 5, 10, 25, 50],
        total: 1,
        to: 1,
        from: 1,
        firstPage: 1,
        lastPage: 1,
        nextPage: 0,
        previousPage: 0,
      },
    };
  },
};
</script>

<style>
#payment_summary tbody tr:nth-of-type(odd) {
  background-color: #fff !important;
}

#payment_summary
  .theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > tbody
  > tr:not(:last-child)
  > td:not(.v-data-table__mobile-row) {
  border-bottom: thin solid rgba(0, 0, 0, 0.05) !important;
}
</style>
